import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './locales/en';
import zh from './locales/zh';

Vue.use(VueI18n);

const STORAGE_KEY = 'laboratory-web.locale';
const SUPPORTED = ['en', 'zh'];

function readStoredLocale() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED.includes(stored)) {
      return stored;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[i18n] Unable to read locale from storage:', error);
  }

  return null;
}

function detectBrowserLocale() {
  if (typeof window === 'undefined') {
    return 'en';
  }

  const { language, languages } = window.navigator || {};
  const candidates = [];

  if (Array.isArray(languages)) {
    candidates.push(...languages);
  }

  if (language) {
    candidates.push(language);
  }

  for (const locale of candidates) {
    if (typeof locale === 'string') {
      const normalized = locale.toLowerCase();
      if (normalized.startsWith('zh')) {
        return 'zh';
      }
      if (normalized.startsWith('en')) {
        return 'en';
      }
    }
  }

  return 'en';
}

const initialLocale = readStoredLocale() || detectBrowserLocale();

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    zh,
  },
});

export function setLocale(locale) {
  if (!SUPPORTED.includes(locale)) {
    return;
  }

  if (i18n.locale === locale) {
    return;
  }

  i18n.locale = locale;

  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(STORAGE_KEY, locale);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('[i18n] Unable to persist locale:', error);
    }
  }
}

export function getSupportedLocales() {
  return [...SUPPORTED];
}

export default i18n;
